export default __webpack_public_path__ + "static/media/spotify-original.7c2b865a.svg";